import React, { useCallback } from "react";

import { faA, faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "antd";
import Tooltip from "antd/es/tooltip";
import { Editor } from "slate";
import { useSlate } from "slate-react";

import AnyColor from "@mapmycustomers/shared/types/AnyColor";

import ColorDropdown from "../../../../colorComponents/ColorDropdown";
import { useConfigProvider } from "../../../../ConfigProvider";
import ToggleButton from "../ToggleButton";

import styles from "./Toolbar.module.scss";

const TextColorToggler = () => {
  const editor = useSlate();
  const configProvider = useConfigProvider();

  const handleToggleBlock = useCallback(
    (color: AnyColor) => {
      Editor.addMark(editor, "color", color);
    },
    [editor]
  );

  const color = Editor.marks(editor)?.color ?? ("black" as AnyColor);

  return (
    <ColorDropdown
      colorPanelProps={{ showColorSpace: true, showNamedColors: true }}
      onChange={handleToggleBlock}
      placement="top"
      value={color}
    >
      <Tooltip title={configProvider.formatMessage("ui.emailBody.toolbar.textColor")}>
        <ToggleButton>
          <Row align="middle" className={styles.toggleButtonContent} gutter={4}>
            <Col>
              <FontAwesomeIcon
                icon={faA}
                style={{
                  borderBottom: `2px solid ${color}`,
                }}
              />
            </Col>
            <Col>
              <FontAwesomeIcon className={styles.dropDownChevron} icon={faChevronDown} size="xs" />
            </Col>
          </Row>
        </ToggleButton>
      </Tooltip>
    </ColorDropdown>
  );
};

export default TextColorToggler;
